import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { organizationTypes } from '../mockData/organization-types-data';

const OrganizationTypesApi = [
  rest.get(`${API_ROOT}libraries/organization-types`, (req, res, ctx) => res(ctx.json(organizationTypes))),
  rest.get(`${API_ROOT}libraries/organization-types/${organizationTypes[0].id}`, (req, res, ctx) => res(ctx.json(organizationTypes[0]))),
  rest.put(`${API_ROOT}libraries/organization-types/${organizationTypes[0].id}`, (req, res, ctx) => res(ctx.json(organizationTypes[0]))),
  rest.post(`${API_ROOT}libraries/organization-types`, (req, res, ctx) => res(ctx.json(organizationTypes[1]))),
  rest.delete(`${API_ROOT}libraries/organization-types`, (req, res, ctx) => {
    const id = req.url.searchParams.get('id');
    if (id === organizationTypes[0].id) {
      return res(ctx.json(organizationTypes[0]));
    }
    return res(ctx.json({}));
  }),
];

export default OrganizationTypesApi;
